import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { reducedMotion } from "../../styles/breakpoints";

const useStyles = createUseStyles({
  /**
   * Full-screen blocking overlay.
   *
   * Previously this rendered *two* stacked fixed layers — a dark
   * `rgba(0,0,0,0.4)` one from this file and a light `rgba(255,255,255,0.8)`
   * one declared inline in the component — so the result was a muddy grey that
   * matched neither. There is now a single layer.
   */
  container: {
    position: "fixed",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
    backgroundColor: "rgba(255, 255, 255, 0.82)",
    backdropFilter: "blur(2px)",
    /* Was 999999999. Uses the shared stacking token so the loader sits above
       dialogs without starting another z-index arms race. */
    zIndex: "var(--z-overlay)",
  },

  spinner: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: `4px solid ${colors.default}`,
    borderTopColor: colors.primary,
    /* `spin` is defined once in index.css. */
    animation: "$spin 1s linear infinite",
    [reducedMotion]: {
      /* A spinner that cannot spin still needs to read as "busy", so it
         pulses gently instead of freezing. */
      animation: "$pulse 1.2s ease-in-out infinite",
    },
  },

  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },

  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.4 },
  },

  label: {
    margin: 0,
    fontFamily: "Poppins-Medium, sans-serif",
    fontSize: 15,
    color: colors.BLACK,
  },
});

export default useStyles;
